<template>
  <div class="operation-report-show-body-form-item flex flex-col"></div>
</template>

<script>
export default {
  name: "FormItemSpace",
};
</script>
